import React, { useState, useEffect } from "react";
import Api from "../services/api";

export default function SelectExpedicoes(props) {
  const [list, setList] = useState([]);

  useEffect(() => {
    loadExpedicoes();
  }, []);

  function loadExpedicoes() {
    Api.get("/expedicoes/list")
      .then((response) => {
        setList(response.data || []);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      });
  }

  const rows =
    list &&
    list.map((expedicao, index) => {
      return (
        <option
          value={expedicao.id}
          selected={props.selected == expedicao.id ? true : false}
          key={index}
        >
          {expedicao.nome_pt}
        </option>
      );
    });

  return (
    <select {...props.register} onChange={props.handleChange}>
      <option value="">— Nenhuma —</option>
      {rows}
    </select>
  );
}
